export const chatTranslations = {
  en: {
    messages: 'Messages',
    newDirect: 'New Direct Message',
    createGroup: 'Create Group',
    close: 'Close',
    searchConversations: 'Search conversations…',
    noConversations: 'No conversations yet',
    messageDeleted: 'Message deleted',
    noMessages: 'No messages yet',
    all: 'All',
    media: 'Media',
    docs: 'Docs',
    emptyAll: 'No messages yet — say hello! 👋',
    emptyMedia: 'No images shared yet',
    emptyDocs: 'No documents shared yet',
    online: 'online',
    members: 'members',
    groupSettings: 'Group Settings',
    viewFullSize: 'View full size',
    download: 'Download',
    deleteMessage: 'Delete Message',
    downloadFile: 'Download File',
    selectConversation: 'Select a conversation to start chatting',
    typeMessage: 'Type a message… (Enter to send)',
    emoji: 'Emoji',
    attachFile: 'Attach File',
    send: 'Send',
    fileTypeNotAllowed: 'File type not allowed.',
    failedToSend: 'Failed to send.',
    attachment: 'Attachment',
    newMessage: 'New Message',
    searchUsers: 'Search users…',
    noUsersFound: 'No users found',
    createGroupChat: 'Create Group Chat',
    groupName: 'Group Name',
    addMembers: 'Add Members',
    membersCount: 'Members',
    makeAdmin: 'Make Admin',
    removeAdmin: 'Remove Admin',
    removeFromGroup: 'Remove from Group',
    admin: 'Admin',
    cancel: 'Cancel',
    creating: 'Creating…',
    createGroupBtn: 'Create Group',
    sending: 'Sending…',
    leaveGroup: 'Leave Group',
    deleteGroup: 'Delete Group',
    leaveGroupConfirm: 'Are you sure you want to leave this group?',
    deleteGroupConfirm: 'Are you sure you want to delete this group? All messages will be removed.',
    groupDeleted: 'Group has been deleted',
    leftGroup: 'You left the group',
    allConversations: 'All Conversations',
    failedAddMember: 'Failed to add member',
    failedRemoveMember: 'Failed to remove member',
    failedMakeAdmin: 'Failed to delegate admin',
    failedRemoveAdmin: 'Failed to revoke admin',
    back: 'Back',
    moreOptions: 'More options',
    yesterday: 'Yesterday',
    removeFile: 'Remove file',
  },
  ar: {
    messages: 'الرسائل',
    newDirect: 'رسالة مباشرة جديدة',
    createGroup: 'إنشاء مجموعة',
    close: 'إغلاق',
    searchConversations: 'ابحث في المحادثات…',
    noConversations: 'لا توجد محادثات بعد',
    messageDeleted: 'تم حذف الرسالة',
    noMessages: 'لا توجد رسائل',
    all: 'الكل',
    media: 'الوسائط',
    docs: 'المستندات',
    emptyAll: 'لا توجد رسائل بعد — قل مرحباً! 👋',
    emptyMedia: 'لم تتم مشاركة صور بعد',
    emptyDocs: 'لم تتم مشاركة مستندات بعد',
    online: 'متصل',
    members: 'أعضاء',
    groupSettings: 'إعدادات المجموعة',
    viewFullSize: 'عرض بالحجم الكامل',
    download: 'تحميل',
    deleteMessage: 'حذف الرسالة',
    downloadFile: 'تحميل الملف',
    selectConversation: 'اختر محادثة للبدء في الدردشة',
    typeMessage: 'اكتب رسالة… (Enter للإرسال)',
    emoji: 'إيموجي',
    attachFile: 'إرفاق ملف',
    send: 'إرسال',
    fileTypeNotAllowed: 'نوع الملف غير مسموح به.',
    failedToSend: 'فشل الإرسال.',
    attachment: 'مرفق',
    newMessage: 'رسالة جديدة',
    searchUsers: 'ابحث عن مستخدم…',
    noUsersFound: 'لا يوجد مستخدمون',
    createGroupChat: 'إنشاء محادثة جماعية',
    groupName: 'اسم المجموعة',
    addMembers: 'إضافة أعضاء',
    membersCount: 'الأعضاء',
    makeAdmin: 'ترقية لمشرف',
    removeAdmin: 'إزالة صلاحية المشرف',
    removeFromGroup: 'إزالة من المجموعة',
    admin: 'مشرف',
    cancel: 'إلغاء',
    creating: 'جاري الإنشاء…',
    createGroupBtn: 'إنشاء المجموعة',
    sending: 'جاري الإرسال…',
    leaveGroup: 'مغادرة المجموعة',
    deleteGroup: 'حذف المجموعة',
    leaveGroupConfirm: 'هل أنت متأكد أنك تريد مغادرة هذه المجموعة؟',
    deleteGroupConfirm: 'هل أنت متأكد أنك تريد حذف هذه المجموعة؟ سيتم حذف جميع الرسائل.',
    groupDeleted: 'تم حذف المجموعة',
    leftGroup: 'لقد غادرت المجموعة',
    allConversations: 'جميع المحادثات',
    failedAddMember: 'فشل إضافة العضو',
    failedRemoveMember: 'فشل إزالة العضو',
    failedMakeAdmin: 'فشل تفويض الصلاحية',
    failedRemoveAdmin: 'فشل سحب الصلاحية',
    back: 'رجوع',
    moreOptions: 'المزيد',
    yesterday: 'أمس',
    removeFile: 'إزالة الملف',
  },
};

export type ChatLang = typeof chatTranslations['en'];
